// Ludvara theme JS
document.addEventListener('DOMContentLoaded', function () {
  // FAQ accordion
  document.querySelectorAll('[data-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      item.classList.toggle('open');
    });
  });
});
